module.exports = __webpack_public_path__ + "img/u127.b2c4240c.png";